// Copyright (c) 2022 Celadon Development LLC, All rights reserved.
// Author Alexander Mikholap <alexander.mikholap@celadon.ae>
import React from 'react';

import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { Input, Button } from '../../../../components';

import styles from './styles';


const Redeem = (props) => {
  const {
    classes,
    balance,
    value,
    valueStatus,
    changeRedeemValue,
    openConfirmModal,
  } = props;

  return (
    <div className={classes.container}>
      <p className={classes.headerText}>Redeem gift voucher now?</p>
      <div className={classes.row}>
        <p className={classes.descText}>Balance: </p>
        <p className={classes.text}>{`£${parseFloat(balance).toFixed(2)}`}</p>
      </div>
      <Input
        value={value}
        name={'value'}
        onChange={changeRedeemValue}
        placeholder={'Enter amount'}
      />
      {!valueStatus.status && (
        <p className={classes.validateText}>
          {valueStatus.message}
        </p>
      )}
      <div className={classes.buttonContainer}>
        <Button
          upperCase={true}
          text={'submit'}
          onPress={openConfirmModal}
        />
      </div>
    </div>
  );

};

Redeem.propTypes = {
  classes: PropTypes.object,
  balance: PropTypes.number,
  valueStatus: PropTypes.object,
  value: PropTypes.string,

  changeRedeemValue: PropTypes.func,
  openConfirmModal: PropTypes.func,
};
Redeem.defaultProps = {
  classes: {},
  balance: 0,
  value: '',
  valueStatus: {},

  changeRedeemValue: () => { },
  openConfirmModal: () => { },
};

export default withStyles(styles)(Redeem);
